import { render, staticRenderFns } from "./birthdays.vue?vue&type=template&id=045a9f0d&scoped=true&"
import script from "./birthdays.vue?vue&type=script&lang=js&"
export * from "./birthdays.vue?vue&type=script&lang=js&"
import style0 from "./birthdays.vue?vue&type=style&index=0&id=045a9f0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a9f0d",
  null
  
)

export default component.exports